import { useEffect, useState, useRef } from "react";
import SVG from "react-inlinesvg";
import { Modal, Form, Nav, Tab, Row, Col } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../../../../../_metronic/_helpers";
import {
    formatAmount,
    formatDate,
    permissionAllow,
    statusColourName
} from "../../../../../../../../../../util/Helpers"
import { useApproveDepositMutation, useApproveWithdrawalMutation, useDeclineWithdrawalMutation, useGetDocumentsQuery } from "../../../../../../../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { Permissions, PermissionType } from "../../../../../../../../../../util/Permissions";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as handlers from "../../../../../../../../_redux/selected-user/selectedUserHandlers";
import { DocumentTab } from "../../../../../../../../../PendingKyc/pages/modal/sections/documents";
import PendingDocumentModalSkeleton from "../../../../../../../../../PendingKyc/pages/modal/PendingDocumentModalSkeleton";
import PaymentDocument from "../../../../../../../../../PendingKyc/pages/modal/sections/documents/PaymentDocument";


const ViewPaymentModal = ({ showViewPaymentModal, details, onHide, tableRef }) => {

   
    const adminUser = useSelector(state => state.auth.user);

    const { accountId, userGroup: routeUserGroup } = useParams() ;
    const userId = useSelector(state => state.auth.user.userId);
    const dispatch = useDispatch();
    const documentQueryArgs = {
        userGroup: details?.userGroup || routeUserGroup || "",
        userId: details?.userId || "",
    };
    const canLoadDocuments = Boolean(documentQueryArgs.userGroup && documentQueryArgs.userId);
    const { isLoading, data } = useGetDocumentsQuery(documentQueryArgs, { skip: !canLoadDocuments });

    const [validated, setValidated] = useState(false);
    const [fileName, setFileName] = useState("");
    const document = useRef("");

    const [
        approveDeposit, // This is the mutation trigger
        {
            isLoading: isApprovingDeposit,
            isSuccess: approvedDepositSuccessfully,
        }, // This is the destructured mutation result
    ] = useApproveDepositMutation();

    const [
        approveWithdrawal, // This is the mutation trigger
        {
            isLoading: isApprovingWithdrawal,
            isSuccess: approvedWithdrawalSuccessfully,
        }, // This is the destructured mutation result
    ] = useApproveWithdrawalMutation();

    const [
        declineWithdrawal, // This is the mutation trigger
        {
            isLoading: isDecliningWithdrawal,
            isSuccess: declineWithdrawalSuccessfully,
        }, // This is the destructured mutation result
    ] = useDeclineWithdrawalMutation();




    /* File input Check */
    const fileSelected = e => {
        const file = e.target.files[0];
        document.current = "";
        setFileName(file.name);

        if (!(/(?<=\S+)\.(jpg|png|jpeg)/gi.test(file.name))) {
            cogoToast.error("Invalid File Selection");
            return
        }

        if (file.size > 10000000) {
            cogoToast.error("File too large (10mb Max)");
            return
        }

        /* Convert File to base64 */
        const reader = new FileReader()
        reader.readAsDataURL(file);

        reader.onload = _ => {
            document.current = reader.result
        };

        reader.onerror = e => {
            cogoToast.error(e.message);
        }
    }

    /* Upload Document */
    const handleSubmit = e => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;

        if (form.checkValidity() && document.current !== "") {
            onHide();
            const formData = new FormData(form);
            const docData = { ...Object.fromEntries(formData.entries()), document: document.current };
            docData.refId = details.ref
            docData.purpose = "PAYMENT_SUPPORT"
            dispatch(handlers.uploadUserDocument(details.userId, docData));
            cogoToast.success("Uploaded Supporting Document Successfully")
            onHide()
        }

        setValidated(true);
    }


    /* Close Modal on Successful Approval */
    useEffect(() => {
        if (approvedDepositSuccessfully || approvedWithdrawalSuccessfully || declineWithdrawalSuccessfully) {
            cogoToast.success(`${approvedDepositSuccessfully ? "Deposit" : "Withdrawal"} ${declineWithdrawalSuccessfully ? "Declined" : "Approved"} Successfully`);
            onHide();
            if (tableRef) {
                tableRef.current.refresh()
            }
            else if (userId && accountId) {
                dispatch(handlers.fetchUserAccountDetails(userId, accountId));
            }
        }
    }, [approvedDepositSuccessfully, approvedWithdrawalSuccessfully, declineWithdrawalSuccessfully, onHide, dispatch, accountId, userId, tableRef]);

    /* Approve Payment */
    const approve = _ => {
        const { ref, userId } = details
        const data = {
            ref,
            userId,
            meta: details
        }

        if (details?.type === "DEPOSIT") {
            approveDeposit(data)
        } else if (details?.type === "WITHDRAW") {
            approveWithdrawal(data)
        }
        else if (details?.type === "CARD_CREATION") {
            approveDeposit(data)
        }
        else if (details?.type === "CARD_DEPOSIT") {
            approveDeposit(data)
        }
        else if (details?.type === "PORTFOLIO_CREATION") {
            approveDeposit(data)
        }
    }

    const progress = details?.progress.map((row, i) => <div key={`progres-${i}`}
        className="timeline-item align-items-start">
        {/*begin::Badge--> */}
        <div className="timeline-badge">
            <i className={`fa fa-genderless text-${statusColourName(row.status)} icon-xl`} />
        </div>
        {/*end::Badge--> */}
        {/*begin::Content--> */}
        <div className="timeline-content d-flex">
            <span className="font-weight-bolder text-dark-75 pl-3 font-size-lg">{row.status}</span>
            <span className="font-weight-bolder text-muted pl-3 font-size-lg">{formatDate(row.date)}</span>
            <span className="pl-3 pt-1 text-muted"> - {row.activity}</span>
        </div>
        {/*end::Content--> */}
    </div>);


    return (
        <Modal

            show={showViewPaymentModal}
            onHide={onHide}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Form
                noValidate
                validated={validated}
                onSubmit={handleSubmit}
            >

                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <span
                            className={`svg-icon svg-icon-lg svg-icon-${details?.type === "DEPOSIT" ? "primary" : "danger"} mr-3`}>
                            <SVG
                                title=""
                                src={toAbsoluteUrl("/media/svg/icons/Shopping/Gift.svg")}
                            />
                        </span>
                        Payment Details
                    </Modal.Title>
                    <button type="button" className="close" onClick={onHide}>
                        <span aria-hidden="true" className="d-block">×</span>
                        <span className="sr-only">Close</span>
                    </button>
                </Modal.Header>
                <Modal.Body
                    className="px-10 pt-2 pb-5"
                >

                    <Tab.Container defaultActiveKey={"Details"}>
                                        
                    {details?.type === "DEPOSIT" && details?.meta?.auth?.countryCode && details?.meta?.auth?.countryCode != "NG" 
                            ?

                            <>
                                <div class="alert alert-warning alert-dismissible fade show" role="alert">
                                    <strong>Hello!</strong> This deposit was initiated with a foreign card.
                                </div>

                            </>
                            :
                            null

                        } 
                        <Nav
                            className="d-flex w-100 px-4 border-bottom align-items-center bg-white position-sticky top-0"
                            style={{
                                height: "46px",
                                zIndex: 1
                            }}
                        >
                            <Nav.Item>
                                <Nav.Link className="px-3" eventKey={"Details"}>
                                    <div>Details</div>
                                </Nav.Link>
                            </Nav.Item>
                            {canLoadDocuments ? (
                                <Nav.Item>
                                    <Nav.Link className="px-3" eventKey={"Supporting Documents"}>
                                        <div>Supporting Documents</div>
                                    </Nav.Link>
                                </Nav.Item>
                            ) : null}

                        </Nav>
                        <Tab.Content className={"h-100 mx-7 mb-7"}>
                            <Tab.Pane eventKey={"Details"} className={"h-100"}>
                                <div className="row">
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Reference</h6>
                                        <span className="text-muted">{details?.ref}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Gateway Reference</h6>
                                        <span className="text-muted">{details?.gatewayRef ?? "Nil"}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg py-4">
                                        <h6 className=" px">User ID</h6>
                                        <span className="text-muted">{details?.userId}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Account ID</h6>
                                        <span className="text-muted">{details?.accountId ?? "Nil"}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Status</h6>
                                        <span className="text-muted">{details?.status}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Rate</h6>
                                        <span className="text-muted">{details?.rate}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Amount</h6>
                                        <span className="text-muted">{formatAmount(details?.currency, details?.amount)}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Sevice Fee</h6>
                                        <span className="text-muted">{formatAmount(details?.currency, details?.serviceFee)}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Payment Type</h6>
                                        <span className="text-muted">{details?.type}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Payment Method</h6>
                                        <span className="text-muted">{details?.method ?? "Nil"}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Instant Fee</h6>
                                        <span className="text-muted">{formatAmount(details?.currency, details?.instantFee)}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Process Fee</h6>
                                        <span className="text-muted">{formatAmount(details?.currency, details?.processFee)}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Payment Gateway</h6>
                                        <span className="text-muted">{details?.gateway?.toUpperCase()}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Instant Deposit</h6>
                                        <span className="text-muted">{details?.instantDeposit ? "True" : "False"}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Last 4 Digit</h6>
                                        <span className="text-muted">{details?.last4 ?? "Nil"}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Total</h6>
                                        <span className="text-muted">{formatAmount(details?.currency, details?.total)}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-3 py-4">
                                        <h6 className=" px">IP</h6>
                                        <span className="text-muted">{details?.ip ?? "Nil"}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Updated At</h6>
                                        <span className="text-muted">{formatDate(details?.updatedAt)}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Created At</h6>
                                        <span className="text-muted">{formatDate(details?.createdAt)}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Instant Deposit Comment</h6>
                                        <span className="text-muted">{details?.instantComment ?? "Nil"}</span>
                                    </div>
                                    <div className="col-lg py-4">
                                        <h6 className=" px">Payment Description</h6>
                                        <span className="text-muted">{details?.description ?? "Nil"}</span>
                                    </div>
                                </div>

                                <h4 className="mt-5 text-primary">Payment Status Progress</h4>

                                {
                                    progress?.length === 0
                                        ? <span className="text-muted">Nil</span>
                                        : <div className="timeline timeline-7 mt-5">{progress}</div>
                                }
                                {
                                    details?.meta && <>
                                        <div className="row">
                                            <div className="col-lg">
                                                <h4 className="mb-4 pt-5 mt-5 text-muted h5">More Details</h4>
                                                <div className="text-muted bg-light-secondary rounded-lg p-4 overflow-auto" style={{ maxHeight: "300px" }}>
                                                    <pre className="mb-0">{JSON.stringify(details?.meta, null, 4)}</pre>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }


                            </Tab.Pane>
                            <Tab.Pane eventKey={"Supporting Documents"}  >

                                {
                                    !canLoadDocuments
                                        ? <div className="text-muted py-6">Supporting documents are unavailable for this payment record.</div>
                                        : isLoading
                                        ? <PendingDocumentModalSkeleton />


                                        : <Tab.Container id="left-tabs-example" defaultActiveKey={data?.docs?.[0]?.documentId}  >

                                            <Row className={"h-100 "} >

                                                <Col
                                                    sm={4}
                                                    className={"border-right h-100 overflow-auto"}
                                                >
                                                    <Nav className={"h-100 "} >
                                                        {data?.docs?.map(({ documentId, type, status, document }) => (

                                                            <DocumentTab
                                                                key={documentId}
                                                                dataKey={documentId}
                                                                status={status}
                                                                src={document}
                                                                title={type.replaceAll("_", " ").toLowerCase()}
                                                            />
                                                        ))}
                                                    </Nav>


                                                    <Nav.Item>
                                                        <Nav.Link className="px-5 py-7" eventKey={"Upload Document"}>

                                                            <button
                                                                className="btn btn-primary font-weight-bolder font-size-sm btn-elevate px-4"
                                                            >
                                                                <span className="svg-icon svg-icon-md svg-icon-white">
                                                                    <SVG
                                                                        title=" "
                                                                        src={toAbsoluteUrl("/media/svg/icons/Files/Uploaded-file.svg")}
                                                                    />
                                                                </span>
                                                                Upload A Document
                                                            </button>
                                                           
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                </Col>

                                                <Col sm={8} className={"h-100 overflow-auto"} >
                                                    <Tab.Content className={"h-100"}>
                                                        {data?.docs?.map((doc) => (
                                                            <Tab.Pane key={doc.documentId} eventKey={doc.documentId} style={{ height: "calc(100vh - 220px)" }}>
                                                                <PaymentDocument
                                                                    initialValues={doc}
                                                                    isEditable={permissionAllow(adminUser, Permissions.PENDING_KYC, PermissionType.UPDATE)}
                                                                />
                                                            </Tab.Pane>
                                                        ))}
                                                    
                                                        
                                                    </Tab.Content>


                                                    <Tab.Content className={"h-100"}>

                                                        <Tab.Pane key={"Upload Document"} eventKey={"Upload Document"} className={"h-100"}>
                                                            <div className="col-lg py-4">
                                                                <h3 class="row justify-content-center"> Upload A Supporting Document</h3>

                                                            </div>



                                                            <Form.Row>
                                                                <Form.Group as={Col} md="6" controlId="type">

                                                                    <Form.Label >Purpose</Form.Label>
                                                                    <Form.Control
                                                                        required
                                                                        as="select"
                                                                        className="mr-sm-2"
                                                                        custom
                                                                        name="type"
                                                                    >
                                                                        <option value=""></option>
                                                                        <option value="PICTURE_ID">Picture ID</option>
                                                                        <option value="PROOF_OF_ADDRESS">Proof of Address</option>
                                                                        <option value="PICTURE_ID_PROOF_OF_ADDRESS">Picture ID w/ Proof of Address</option>
                                                                        <option value="TAX">Tax</option>
                                                                        <option value="TRUST_DOCUMENTS">Trust</option>
                                                                    </Form.Control>
                                                                    <Form.Control.Feedback type="invalid">Please provide document Category</Form.Control.Feedback>
                                                                </Form.Group>
                                                                <Form.Group as={Col} md="6" controlId="idType">
                                                                    <Form.Label >Type</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="idType"
                                                                    />
                                                                </Form.Group>
                                                                
                                                            </Form.Row>
                                                            <Form.Row>
                                                                <Form.Group as={Col} md="6" controlId="idValue">
                                                                    <Form.Label >Type Value (optional)</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="idValue"
                                                                    />
                                                                </Form.Group>
                                                                <Form.Group as={Col} md="6" controlId="document">
                                                                    <Form.Label >File</Form.Label>
                                                                    <Form.File
                                                                        lang="en"
                                                                        custom
                                                                        id="formcheck-api-custom"
                                                                    >
                                                                        <Form.File.Input
                                                                            required
                                                                            onChange={fileSelected}
                                                                            accept=".jpg, .jpeg, .png"
                                                                        />
                                                                        <Form.File.Label data-browse="Select">{fileName}
                                                                        </Form.File.Label>
                                                                        <Form.Control.Feedback type="invalid">
                                                                            Select document File
                                                                        </Form.Control.Feedback>
                                                                    </Form.File>
                                                                </Form.Group>
                                                               
                                                               
                                                            </Form.Row>
                                                            <button
                                                                type="button"
                                                                onClick={onHide}
                                                                className="btn btn-light btn-elevate px-4"
                                                            >
                                                                Cancel
                                                            </button>
                                                            <> </>
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary btn-elevate px-4 ml-4"
                                                            >
                                                                Upload
                                                            </button>
                                                        </Tab.Pane>

                                                    </Tab.Content>
                                                </Col>
                                            </Row>


                                        </Tab.Container>
                                }

                            </Tab.Pane>



                        </Tab.Content>
                    </Tab.Container>

                </Modal.Body>
            </Form>
            <Modal.Footer>
                {
                    (
                        (
                            (details?.status === "PENDING_CONFIRMATION" && details?.type === "WITHDRAW") ||
                            (details?.status === "PROCESSING" && details?.type === "DEPOSIT") ||
                            (details.status === "PROCESSING" && details.type === "CARD_CREATION") ||
                            (details.status === "PROCESSING" && details.type === "CARD_DEPOSIT") ||
                            (details?.status === "PROCESSING" && details?.type === "PORTFOLIO_CREATION")
                        ) &&
                        permissionAllow(adminUser, Permissions.PAYMENTS, PermissionType.UPDATE)
                    ) ? <>
                        <button
                            type="button"
                            disabled={isApprovingDeposit || isApprovingWithdrawal || isDecliningWithdrawal}
                            onClick={approve}
                            className={`btn btn-primary btn-elevate px-5 ml-5`}
                        >
                            Approve
                        </button>

                        {
                            details?.type === "WITHDRAW" ?
                                <button
                                    type="button"
                                    disabled={isApprovingDeposit || isApprovingWithdrawal || isDecliningWithdrawal}
                                    onClick={_ => declineWithdrawal({ ref: details?.ref, userId: details?.userId, meta: details })}
                                    className="btn btn-danger btn-elevate px-5 ml-5"
                                >
                                    Decline
                                </button>
                                :
                                <button
                                    type="button"
                                    onClick={onHide}
                                    className="btn btn-secondary btn-elevate px-5 ml-5"
                                >
                                    Cancel
                                </button>
                        }
                    </>
                        : <>
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-secondary btn-elevate px-5"
                            >
                                Okay
                            </button>
                        </>
                }

            </Modal.Footer>


        </Modal>

    );
}

export default ViewPaymentModal;